import { render, staticRenderFns } from "./CardIssueConfig.vue?vue&type=template&id=69e3494c&scoped=true"
import script from "./CardIssueConfig.vue?vue&type=script&lang=js"
export * from "./CardIssueConfig.vue?vue&type=script&lang=js"
import style0 from "./CardIssueConfig.vue?vue&type=style&index=0&id=69e3494c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e3494c",
  null
  
)

export default component.exports